import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box, Typography, useTheme } from '@mui/material'
import { EventType } from '@/features/events/shared/types'
import { ToolHeader } from '../shared'

interface WebSearchContextRendererProps {
  readonly query: string
}

export const WebSearchContextRenderer: FC<WebSearchContextRendererProps> = ({ query }) => {
  const theme = useTheme()

  return (
    <>
      <ToolHeader eventType={EventType.TOOL_PERMISSION_REQUEST} toolName="WebSearch" />

      <Box sx={queryContainerSx}>
        <Typography variant="body2" sx={queryValueSx(theme)}>
          &quot;{query}&quot;
        </Typography>
      </Box>
    </>
  )
}

const queryContainerSx: SxProps<Theme> = {
  mt: 1,
}

const queryValueSx = (theme: Theme): SxProps<Theme> => ({
  fontStyle: 'italic',
  color: theme.palette.text.secondary,
  wordBreak: 'break-word',
  whiteSpace: 'pre-wrap',
  fontSize: 'inherit',
})
